import firebase from 'firebase';
import 'firebase/firestore';
import axios from "../apiService/config/axios";
import { store } from './store';

const config = {
  apiKey: process.env.apiKey,
  authDomain: process.env.authDomain,
  databaseURL: process.env.databaseURL,
  projectId: process.env.projectId,
  storageBucket: process.env.storageBucket,
  messagingSenderId: process.env.messagingSenderId,
  appId: process.env.appId
}

firebase.initializeApp(config);
firebase.auth().languageCode = 'es';

// firebase utils
const db = firebase.firestore();


firebase.auth().onAuthStateChanged(async user => {
  if (user) {
    const token = await user.getIdToken();
    store.dispatch("saveToken", token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
});


export {
  db,
  auth
};



// WEBPACK FOOTER //
// ./src/js/firebaseConfig.js